import { api_host } from '../../common/globals/constants';

export async function getDynamicPanelsUser({ favourites = false }) {
  const token = sessionStorage.getItem('key');

  const response = await fetch(
    `${api_host}/reporte/online/indicadores/PanelDinamicoViewSet/getPanelesDinamicosUsuario/?token=${token}&favourites=${favourites}&fecha=${new Date().getTime()}`
  );

  if (!response.ok) {
    throw new Error('Error fetching dynamic panels for user');
  }

  return await response.json();
}

export async function getDynamicPanelHomeUser() {
  const token = sessionStorage.getItem('key');

  const response = await fetch(
    `${api_host}/reporte/online/indicadores/PanelDinamicoViewSet/getPanelDinamicoHomeUsuario/?token=${token}&fecha=${new Date().getTime()}`
  );

  if (!response.ok) {
    throw new Error('Error fetching dynamic panels for user');
  }

  return await response.json();
}

export async function createDynamicPanel(data) {
  const token = sessionStorage.getItem('key');

  const response = await fetch(
    `${api_host}/reporte/online/indicadores/PanelDinamicoViewSet/createPanelDinamicoUsuario/?token=${token}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({token, ...data}),
    }
  );

  if (!response.ok) {
    throw new Error('Error creating dynamic panel');
  }

  return await response.json();
}

export async function deleteDynamicPanel(panelId) {
  const token = sessionStorage.getItem('key');
  const urlParams = new URLSearchParams({
    panelId,
    token,
  });
  const response = await fetch(
    `${api_host}/reporte/online/indicadores/PanelDinamicoViewSet/deletePanelDinamicoUsuario/?${urlParams.toString()}`,
    {
      method: 'DELETE',
    }
  );
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return await response.json();
}

export async function updateTemplateDynamic({ panelId, data, objetivoId }) {
  const token = sessionStorage.getItem('key');
  
  const response = await fetch(
    `${api_host}/reporte/online/indicadores/PanelDinamicoViewSet/updateEstructuraPanelDinamicoUsuario/?token=${token}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token,
        panelId,
        estructura_panel_dinamico: data,
        objetivo_id:objetivoId
      }),
    }
  );
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return await response.json();
}

export async function toggleFavouriteDynamicPanel({ panelId, isFavourite }) {
  const token = sessionStorage.getItem('key');
  const response = await fetch(
    `${api_host}/reporte/online/indicadores/PanelDinamicoViewSet/updateFavoritoPanelDinamicoUsuario/?token=${token}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token,
        panelId,
        favorito: isFavourite,
      }),
    }
  );
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return await response.json();
}
export async function toggleHomeDynamicPanel({ panelId, enHome }) {
  const token = sessionStorage.getItem('key');
  const response = await fetch(
    `${api_host}/reporte/online/indicadores/PanelDinamicoViewSet/updateStatusMostrarEnHomePanelDinamicoUsuario/?token=${token}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token,
        panelId,
        enHome,
      }),
    }
  );
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return await response.json();
}
